// utils/dateHelpers.js
import { format, startOfWeek, endOfWeek, isWithinInterval, parseISO, subWeeks } from "date-fns";

export const formatDate = (dateString) => {
  return format(parseISO(dateString), "MMM d, yyyy");
};

export const isWithinCurrentWeek = (dateString) => {
  try {
    const date = parseISO(dateString);
    const now = new Date();
    return isWithinInterval(date, {
      start: startOfWeek(now),
      end: endOfWeek(now),
    });
  } catch {
    return false;
  }
};

export const getWeeklyStats = (items = []) => {
  const now = new Date();
  const weekStart = startOfWeek(now);
  const weekEnd = endOfWeek(now);

  return items.reduce(
    (acc, item) => {
      try {
        const purchaseDate = parseISO(item.purchasedDate);
        if (isWithinInterval(purchaseDate, { start: weekStart, end: weekEnd })) {
          acc.count++;
          acc.total += Number(item.total) || 0;
        }
        return acc;
      } catch {
        return acc;
      }
    },
    { count: 0, total: 0 }
  );
};
